var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActivityActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 4,
    viewBox: "0 0 10 4",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.766999 3.9297C0.941138 3.93007 1.11013 3.87067 1.24574 3.76142L2.41088 2.83002C2.64616 2.64114 2.94293 2.54585 3.24418 2.56247C3.54544 2.57909 3.82993 2.70643 4.043 2.92004C4.53474 3.40553 5.18979 3.69027 5.88022 3.71864C6.57065 3.74702 7.24687 3.51699 7.77678 3.07349L9.70197 1.44443C9.784 1.38103 9.85232 1.30167 9.90282 1.21113C9.95332 1.12059 9.98495 1.02076 9.99579 0.917656C10.0066 0.814556 9.99647 0.710326 9.96591 0.611262C9.93536 0.512199 9.88504 0.420355 9.818 0.341278C9.75096 0.262201 9.66859 0.197531 9.57587 0.151173C9.48314 0.104814 9.38198 0.0777292 9.27849 0.0715532C9.17501 0.0653771 9.07134 0.0802381 8.97376 0.115239C8.87618 0.150239 8.7867 0.204654 8.71073 0.275196L6.78605 1.90425C6.55031 2.10082 6.24975 2.20241 5.9431 2.18917C5.63645 2.17593 5.34576 2.0488 5.12784 1.83264C4.64811 1.35156 4.00761 1.06461 3.32927 1.02685C2.65093 0.989089 1.98253 1.20319 1.45238 1.62805L0.287746 2.56354C0.163667 2.66287 0.0735 2.79829 0.0297031 2.95107C-0.0140938 3.10386 -0.00935847 3.26647 0.0432547 3.41645C0.0958678 3.56643 0.193762 3.69637 0.32341 3.78831C0.453058 3.88025 0.60806 3.92965 0.766999 3.9297Z",
    fill: "#45185A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivityActive);
export default __webpack_public_path__ + "static/media/ActivityActive.f5ab5b927273a65842415d30b7f9014d.svg";
export { ForwardRef as ReactComponent };